import { getCountryMaskFile as s } from "./masks/mask.js";
import { useFormStore as m } from "../stores/form.js";
import { getCountryValidatorFile as l } from "./validators/validate.js";
import { storeToRefs as u } from "pinia";
const g = async (o, t = "en") => {
  const e = m(), { countryCode: r, countryMaskFile: a, countryValidatorFile: i, language: n } = u(e);
  r.value = o, a.value = new (await s(o))(), i.value = new (await l(o))(), n.value = t;
};
export {
  g as default
};
